import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] ${
      dark ? "text-[#D4AF37]" : "text-[#0F574E]"
    }`}
  >
    <span className={`inline-block h-px w-8 ${dark ? "bg-[#D4AF37]" : "bg-[#D4AF37]"}`} />
    {children}
  </p>
);
